import { MBGiphyAPI } from '@shared/scenes/gifs/util/api';

export function fetchTrending(limit: number = 24) {
  return async (dispatch: MBDispatch) => {
    const gifs = await MBGiphyAPI.trending(limit);
    dispatch({ type: 'GIFS:SET_TRENDING', value: { gifs } });
    // Remove error, if set
    dispatch({ type: 'GIFS:SET_IS_ERROR', value: { isError: false } });
  };
}

export function loadMoreTrending(limit: number = 24) {
  return async (dispatch: MBDispatch, getState: MBGetState) => {
    const offset = getState().gifs.trending.length;
    const gifs = await MBGiphyAPI.trending(limit, offset);
    dispatch({ type: 'GIFS:APPEND_TRENDING', value: { gifs } });
    // Remove error, if set
    dispatch({ type: 'GIFS:SET_IS_ERROR', value: { isError: false } });
  };
}

// TODO(fant): if we already have search results and just search (aka not load more)
// we shouldn't request new search results (unnecessarily many reqs to Giphy)
export function search(query: string | null, loadMore: boolean = false, limit: number = 24) {
  return async (dispatch: MBDispatch, getState: MBGetState) => {
    // Only search in API if we have a search query
    if (!!query) {
      let offset = 0;
      // If we have existing search results for a given search query,
      // add the number of results as offset so that we get more GIFs
      // after the already retreived items.
      const previousResultsForQuery = getState().gifs.searchResults[query];
      if (previousResultsForQuery) {
        offset = previousResultsForQuery.length;
      }

      // If we don't have any previous results for query or want to load more,
      // do the actual Giphy API request. We don't want to request more every
      // time a user updates the search query to something where we already
      // have fetched results.
      if (!previousResultsForQuery || loadMore) {
        try {
          const gifs = await MBGiphyAPI.search(query, limit, offset);
          dispatch({ type: 'GIFS:APPEND_SEARCH_RESULTS', value: { gifs, query } });
          // Remove error, if set
          dispatch({ type: 'GIFS:SET_IS_ERROR', value: { isError: false } });
        } catch (e) {
          dispatch({ type: 'GIFS:SET_IS_ERROR', value: { isError: true } });
          console.warn(e);
        }
      }
    }

    // We don't want to update the query in the redux state until after the
    // search results have been returned. By doing this, the old GIF results
    // still appear until there are new ones. Otherwise we will have a white
    // screen while loading
    dispatch({ type: 'GIFS:UPDATE_SEARCH_QUERY', value: { query } });
  };
}
